import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Toggle from 'react-toggle'

const ToggleWithLabel = ({ checked, disabled, label, onChange, className }) => {
  const classNames = cn('toggle-with-label', className)

  return (
    <div className={classNames}>
      <span className="toggle-label">{label}</span>
      <Toggle checked={checked} onChange={onChange} disabled={disabled} />
    </div>
  )
}

ToggleWithLabel.defaultProps = {
  checked: false,
  label: '',
  onChange: () => {},
}

ToggleWithLabel.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default ToggleWithLabel
